import React from 'react';
import './style.css'
import MaterialIcon, {colorPallet} from 'material-icons-react';
import Imagem from './imagem'


class Imagens extends React.Component {

    state = {
        nomeFileInput : undefined,
        edit : false,
        newImagePreview : '',
        big_shadow : {
            width : 0,
            height : 0,
            backgroundImage : null
        }
    }
    struct = {
        img : null,
        desc : null
    }

    onChange = (value) => {
        this.struct.desc = value.target.value
        console.log(this.struct)
    }

    deletarHandler = (id) =>  ()=> this.props.deletarImagem(id)
    
    editarHandler = (id) => () => {
        console.log('let editarHandler = (id) => () =>', this.struct.desc)
        this.props.editarImagem(id, this.struct.desc)
    }

    handleFiles = (files) =>{
        console.log('handleFiles = (files)', files.target.files[0])
        this.struct.img = files.target.files[0];
        this.setState({nomeFileInput : this.struct.img.name, newImagePreview: URL.createObjectURL(this.struct.img)});
    }

    handleDesc = (desc) =>{
        console.log('handleDesc = (desc)', desc.target.value);
        this.struct.desc = desc.target.value;
    }

    render(){

        let {imagens, adicionarImagem} = this.props;

       
        let salvarHandler = (e) =>{
            console.log('salvarHandler = (e)', this.struct)
            adicionarImagem(this.struct.img, this.struct.desc)
            this.fileInput.value  = null;
            this.descInput.value = null;
            this.setState({nomeFileInput : undefined, newImagePreview:''});
        }
        

        let shadowFileInputHandler = () =>{
            this.fileInput.click();
        }

        const AttFileName = ({nome='Clique acima para abrir uma imagem'}) =>{
            return <span className='file_choosed'>{nome}</span>
        }
       
        let imagens_  = imagens.map((obj,k)=>{
            if(!obj) return null
            return <Imagem src={obj.img} desc={obj.desc} 
                isEditing={this.state.edit} 
                onChange={this.onChange} key={k} 
                editar={this.editarHandler(obj.id)} 
                deletar={this.deletarHandler(obj.id)} />
         }) 

        return(
            <div className='outter_container'>
                <h2 className='page_title'>Imagens do Local</h2>
                <div className="imagens_shower">
                    <div className='imagens_new'>
                        <input type="file" style={{display:'none'}} onChange={this.handleFiles}  ref={(e)=>this.fileInput=e} accept=".jpg, .jpeg, .png"/>
                        <div ref={(e)=>this._fileInput=e} onClick={shadowFileInputHandler} className="input_art" style={{backgroundImage:'url('+this.state.newImagePreview+')'}}><MaterialIcon size={100} icon="add_to_photos" /></div>
                        <AttFileName nome={this.state.nomeFileInput}/>
                        <div className='imagens_new_bottom'>                        
                            <input onChange={this.handleDesc} placeholder='Adicione uma descrição' onKeyUp={(e)=>e.keyCode==13?salvarHandler():null} ref={(e)=>this.descInput=e} type="text"/>
                            <div className='save_button' onClick={salvarHandler}><MaterialIcon icon='save' /></div>
                        </div>
                    </div>
                    {imagens_}
                    <div className='big_shadow' style={this.state.big_shadow}></div>
                </div>
            </div>
        )
    }
    
}


export default Imagens


// WEBPACK FOOTER //
// ./src/views/administrativo/imagens/component.js